import Vue from 'vue'

import Router from 'vue-router'

// 测试页面
// import Test from '../views/test.vue'

// 主页
import Index from '../views/Index.vue'
// 新闻
import NewsList from '../views/NewsList.vue'
import NewsDetail from '../views/NewsDetail.vue'
// 加入
import Join from '../views/Join.vue'
// 简介
import Intr from '../views/Intr.vue'
// 交流动态
import Dynamic from '../views/Dynamic.vue'
import DynamicList from '../views/DynamicList.vue'
import DynamicDetail from '../views/DynamicDetail.vue'

//各组织机构
import Organization from '../views/Organization' 
import Committee from '../views/Organization/committee' //专家委员会
import Council from '../views/Organization/Council.vue' //理事会
import Secretary from '../views/Organization/Secretary.vue' //秘书组
import MemberUnit from '../views/Organization/MemberUnit.vue' //成员单位
//各成员
import MemberDetail from '../views/MemberDetail.vue'
// 资料相关
import Literature from '../views/Literature.vue'

// 文献下载
// import GuideBook from '../views/Literature/GuideBook.vue'
// import Information from '../views/Literature/Information.vue'
// import Material from '../views/Literature/Material.vue'
// import Operation from '../views/Literature/Operation.vue'
// import Policy from '../views/Literature/Policy.vue'
// import Rule from '../views/Literature/Rule.vue'
// import Standard from '../views/Literature/Standard.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path:'/test',
    //   name:'Test',
    //   component:Test
    // },
    {
      path: '/',
      name: 'index',
      component: Index
    },

    // 欢迎加入
    {
      path: '/join',
      name: 'join',
      component: Join
    },

    // 简介
    {
      path: '/intr',
      name: 'intr',
      component: Intr
    },

    // 交流动态
    {
      path: '/dynamic',
      name: 'dynamic',
      component: Dynamic
    },
    {
      path: '/dynamiclist',
      name: 'dynamiclist',
      component: DynamicList
    },
    {
      path: '/dynamicdetail',
      name: 'dynamicdetail',
      component: DynamicDetail
    },
    // DynamicDetail

    // 新闻
    // 新闻列表
    {
      path: '/newslist',
      name: 'newslist',
      component: NewsList
    },
    // 新闻详情
    {
      path: '/newsdetail',
      name: 'newsdetail',
      component: NewsDetail
    },

    // 实验室成员
    {
      path: '/memberdetail',
      name: 'memberdetail',
      component: MemberDetail
    },

    // 资料
    {
      path: '/literature',
      name: 'literature',
      component: Literature
    },

    // 组织机构
    // import Organization from '../views/Organization' 
    {
      path: '/organization',
      name: 'organization',
      component: Organization
    },


    // 原交流动态
    // {
    //   path:'/guidebook',
    //   name:'guidebook',
    //   component:GuideBook
    // },
    // {
    //   path:'/information',
    //   name:'information',
    //   component:Information
    // },
    // {
    //   path:'/material',
    //   name:'material',
    //   component:Material
    // },
    // {
    //   path:'/operation',
    //   name:'operation',
    //   component:Operation
    // },
    // {
    //   path:'/policy',
    //   name:'policy',
    //   component:Policy
    // },
    // {
    //   path:'/rule',
    //   name:'rule',
    //   component:Rule
    // },
    // {
    //   path:'/standard',
    //   name:'standard',
    //   component:Standard
    // },

    // 原组织机构
    {
      path:'/committee',
      name:'committee',
      component:Committee
    },
    {
      path:'/council',
      name:'council',
      component:Council
    },
    {
      path:'/secretary',
      name:'secretary',
      component:Secretary
    },
    {
      path:'/memberunit',
      name:'memberunit',
      component:MemberUnit
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js